import sortBy from 'lodash/sortBy';
import { NavigationItem } from 'components/common/types/NavigationItem.types';
import { PoiOption, DataProvidersWithPoiOptions } from 'components/common/types/Planner.types';

export const getCurrentPoiOptions = (
  selectedProvider: string,
  dataProvidersWithPoiOptions: DataProvidersWithPoiOptions | undefined,
  searchTerm: string,
  navigationStack: NavigationItem[],
): PoiOption[] => {
  if (!selectedProvider) return [];

  const initialOptions = dataProvidersWithPoiOptions?.[selectedProvider] || [];

  if (searchTerm.length > 0) {
    const filteredOptions = initialOptions.filter((poi) => poi.name.toLowerCase().includes(searchTerm.toLowerCase()));
    return navigationStack.reduce(
      (options, navItem) => options.find((opt) => opt.name === navItem.title)?.children || [],
      filteredOptions,
    );
  }

  return navigationStack.reduce(
    (options, navItem) => options.find((opt) => opt.name === navItem.title)?.children || [],
    initialOptions,
  );
};

export const initializeDataProvider = (
  dataProviders: string[],
  setSelectedProvider: (provider: string) => void,
): void => {
  if (dataProviders.length === 0) return;

  if (dataProviders.length === 1) {
    setSelectedProvider(dataProviders[0]);
    return;
  }

  const firstDataProviderInSortedList = sortBy(dataProviders)[0];
  setSelectedProvider(firstDataProviderInSortedList);
};
